<div class="wrapper">
  @if (filteredProjectReportsList?.length) {
    <div
      [class.collapsed]="!isExpanded"
      class="reports-list"
      >
      @for (report of filteredProjectReportsList; track report; let i = $index) {
        <app-project-reports-card
          (click)="selectReport(report, i)"
          [report]="report"
          class="each-project-report-card"
          />
      }
    </div>
  }
  @if (projectReportsList?.length > 3) {
    <div
      (click)="handleExpansion()"
      class="see-more text-type-9 flex"
      >
      {{ isExpanded ? 'See less' : 'See more' }}
    </div>
  }
</div>
